var index = {
    data() {
        return {
            id: 0,
            detail: {}
        }
    },
    fetch() {
        if (this.id) {
            this.$api.workgroup.getview({
                id: this.id
            }).then((res) => {
                if (res.R) {
                    var data = res.data;
                    this.detail = data;
                }
            })
        }
    }
}

export default index;